export const disputeDetailsCaseInformation = {
  Area: "",
  Area_code: "",
  Bulk_dispute: false,
  Booking_number: "",
  Brand: "",
  Case_number: "",
  Case_owner: "",
  Contact_name: "",
  Contact_email: "",
  Credit_memo: "",
  Coordinator_code: "",
  Coordinator_function: "",
  Currency: "",
  Charge_code: "",
  Customer_name: "",
  Dispute_type: "",
  Disputed_invoice_number: "",
  Disputed_amount: 0,
  GSC: "",
  Has_credit_note: "",
  Payment_types: "",
  Processor_name: "",
  Price_owner_name: "",
  Price_owner_code: "",
  Reason_code: "",
  Reason: "",
  Root_cause_code: "",
  Root_cause: "",
  Region_code: "",
  Region_name: "",
  Status_code: "",
  Status_description: "",
  Total_invoiced_amount: "",
  Team_leader: "",
  Fscm_changed_at: "",
  Fscm_created_at: "",
};

export const disputeCaseDetails = {
  CM_ID: "",
  Email_address: "",
  Subject: "",
  CM_Owner: "",
  Link_to_CM: "",
  Link_to_CM_parent_case: "",
  Description: "",
};

export const disputeDetailsComments = [
  {
    username: "Debra M Oliver",
    maerskSupportTeam: false,
    time: "Wed Feb 24 2021 19:14:09 GMT+0530 (India Standard Time)",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate",
  },
  {
    username: "John Doe",
    maerskSupportTeam: true,
    time: "Wed Feb 24 2021 17:14:09 GMT+0530 (India Standard Time)",
    description:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.",
  },
  {
    username: "Debra M Oliver",
    maerskSupportTeam: false,
    time: "Wed Feb 23 2021 19:14:09 GMT+0530 (India Standard Time)",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate",
  },
];

export const disputeShipmentNotes = [
  {
    updated_by_user_name: "EDI",
    updated_timestamp: 1613716780545,
    reason: "Product: Booking details modified",
    justification:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  },
  {
    updated_by_user_name: "EDI",
    updated_timestamp: 1613718753040,
    reason: "Product: Conflict",
    justification:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  },
  {
    updated_by_user_name: "EDI",
    updated_timestamp: 1613718753040,
    reason: "Product: Conflict",
    justification:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  },
];

export const disputeShipmentInformation = {
  Booking_number: "",
  Brand_subsidiary: "",
  Shipping_status: "",
  Latest_pcd: "",
  Booked_by_name: "",
  Booked_by_country: "",
  Consignee_country: "",
  Consignee_name: "",
  Origin: "",
  Destination: "",
  Picked_up_ffes: 0,
  Destination_arrival_date: "",
  Shipper_name: "",
  Shipper_scv_code: "",
  Shipper_country: "",
  containers: [
    {
      container_id: "John doe (AMP070)",
      container_type: "2009-12949814",
      move: "GATE-IN",
      activity: "GATE-IN",
      container_group: "40DRY",
      dangerous_cargo: "No",
      equipment_dimensions: "8 6",
      equiment_owner: "OWN",
      equipment_repair_status: "No",
      beer_beverages: "Beer, beverages",
      active_refer: "",
      allow_partial_shipment: "Yes",
    },
    {
      container_id: "John doe (AMP070)",
      container_type: "2009-12949814",
      move: "GATE-IN",
      activity: "GATE-IN",
      container_group: "40DRY",
      dangerous_cargo: "No",
      equipment_dimensions: "8 6",
      equiment_owner: "OWN",
      equipment_repair_status: "No",
      beer_beverages: "Beer, beverages",
      active_refer: "",
      allow_partial_shipment: "Yes",
    },
    {
      container_id: "John doe (AMP070)",
      container_type: "2009-12949814",
      move: "GATE-IN",
      activity: "GATE-IN",
      container_group: "40DRY",
      dangerous_cargo: "No",
      equipment_dimensions: "8 6",
      equiment_owner: "OWN",
      equipment_repair_status: "No",
      beer_beverages: "Beer, beverages",
      active_refer: "",
      allow_partial_shipment: "Yes",
    },
  ],
};

export const disputeAttachments = [
  {
    fileId: "113b8124-304e-48bf-b183-e5eb186b33a6",
    fileName: "Screen Shot 2021-02-12 at 18.33.06.png",
    fileUrl:
      "https://csatomdevstagingsa.blob.core.windows.net/gam/gam-attachments%2FAB55_SGH107_2021-02-17T10%3A57%3A51.168476Z%2FScreen%20Shot%202021-02-12%20at%2018.33.06.png",
    primarykey: "AB55_SGH107_2021-02-17T10:57:51.168476Z",
    productId: "gam-attachments",
    updatedAt: null,
    createdAt: "2021-02-17T10:58:02.546+0000",
    createdBy: "SGH107",
    createdByName: "Samrat Ghosh",
    size: "300kb",
  },
  {
    fileId: "e3729461-41fb-4d95-a03d-dfefe1266130",
    productId: "gam-attachments",
    primarykey: "AB55_SGH107_2021-03-01T11:00:04.219957Z",
    fileName: "Copy of Aadhar Card.pdf",
    fileUrl:
      "https://csatomdevstagingsa.blob.core.windows.net/gam/gam-attachments%2FAB55_SGH107_2021-03-01T11%3A00%3A04.219957Z%2FCopy%20of%20Aadhar%20Card.pdf",
    updatedAt: null,
    createdAt: "2021-03-01T11:00:15.014+0000",
    createdBy: "SGH107",
    createdByName: "Samrat Ghosh",
    size: "350kb",
  },
  {
    fileId: "440581ac-5691-49f6-97f7-eeeecd26c217",
    productId: "gam-attachments",
    primarykey: "AB55_SGH107_2021-03-01T11:00:04.219957Z",
    fileName: "Copy of Samrat - Driving LL.pdf",
    fileUrl:
      "https://csatomdevstagingsa.blob.core.windows.net/gam/gam-attachments%2FAB55_SGH107_2021-03-01T11%3A00%3A04.219957Z%2FCopy%20of%20Samrat%20-%20Driving%20LL.pdf",
    updatedAt: null,
    createdAt: "2021-03-01T11:00:16.461+0000",
    createdBy: "SGH107",
    createdByName: "Samrat Ghosh",
    size: "450kb",
  },
];

export const disputeCardData = [
  {
    label: "Assignee",
    icon: "mi-user-circle",
    slotKey: "disputeAgentName",
    class: "case-owner",
  },
  {
    label: "Dispute stage",
    icon: "mi-info-circle",
    slotKey: "disputeStage",
    class: "root-cause",
  },
  {
    label: "Dispute type",
    icon: "mi-wrench",
    slotKey: "disputeType",
    class: "dispute-type",
  },
  {
    label: "Invoice number",
    icon: "mi-receipt",
    slotKey: "invoiceNumber",
    class: "invoice-number",
  },
  {
    label: "Tp doc number",
    icon: "mi-file",
    slotKey: "tpDocumentNumber",
    class: "tp-doc-number",
  },
  {
    label: "Company description",
    icon: "mi-info-circle",
    slotKey: "companyDescription",
    class: "payment-status",
  },
  {
    label: "Customer",
    icon: "mi-person",
    slotKey: "customer",
    class: "customer",
  },
  {
    label: "Area",
    icon: "mi-pin",
    slotKey: "areaName",
    class: "cluster",
  },
  {
    label: "Customer Name",
    icon: "mi-person",
    slotKey: "customerName",
    class: "customer",
  },
  {
    label: "Reason",
    icon: "mi-magnifying-glass",
    slotKey: "reasonDescription",
    class: "reason",
  },
  {
    label: "GSC",
    icon: "mi-pin",
    slotKey: "gsc",
    class: "invoice-amount",
  },
  {
    label: "Processor name",
    icon: "mi-person",
    slotKey: "processorName",
    class: "disputed-amount",
  },
  {
    label: "Reference key",
    icon: "mi-arrows-down-up",
    slotKey: "referenceKey",
    class: "reference-key",
  },
  {
    label: "Region",
    icon: "mi-pin",
    slotKey: "regionName",
    class: "region-name",
  },
  {
    label: "Created source",
    icon: "mi-file-other",
    slotKey: "createdSource",
    class: "outcome-description",
  },
  {
    label: "Redisputed count",
    icon: "mi-magnifying-glass",
    slotKey: "redisputeCount",
    class: "root-cause",
  },
  {
    label: "Price owner name",
    icon: "mi-person",
    slotKey: "priceOwnerName",
    class: "root-cause",
  },
  {
    label: "Price owner code",
    icon: "mi-magnifying-glass",
    slotKey: "priceOwnerScvCode",
    class: "root-cause",
  },
];

export const disputedChargesConstant = [
  {
    label: "Charge name",
    slotKey: "chargeName",
  },
  {
    label: "Dispute category",
    slotKey: "disputeCategory",
  },
  {
    label: "Current amount",
    slotKey: "currentAmount",
    type: "currency",
  },
  {
    label: "Expected amount",
    slotKey: "expectedAmount",
    type: "currency",
  },
  {
    label: "Disputed amount",
    slotKey: "disputedAmount",
    type: "currency",
  },
];
export const gamStatusInformationConstant = [
  {
    label: "GAM Type",
    slotKey: "ab_type",
  },
  {
    label: "Status",
    slotKey: "status",
  },
  {
    label: "Charge Codes",
    slotKey: "chargeCodes",
  },
  {
    label: "Waiver Amount(USD)",
    slotKey: "waiverAmount",
  },
];
export const manualAutoResolutionDetailsMapping = [
  {
    label: "Charge code",
    slotKey: "charge_type",
  },
  {
    label: "Decision",
    slotKey: "decision",
  },
  {
    label: "Charge Amount",
    slotKey: "chargeAmount",
  },
  {
    label: "View QSR Emails",
    slotKey: "surcharge-emails",
  },
  {
    label: "View SFDC Emails",
    slotKey: "surcharge-sfdc-emails",
  },
  {
    label: "Justification",
    slotKey: "justification",
  },
];
export const autoResolutionDetailsConstant = [
  {
    label: "Charge code",
    slotKey: "charge_type",
  },
  {
    label: "Decision",
    slotKey: "decision",
  },
  {
    label: "Type",
    slotKey: "type",
  },
  {
    label: "Charge Amount",
    slotKey: "chargeAmount",
  },
  {
    label: "Expected charge Amount",
    slotKey: "expectedChargeAmount",
  },
  {
    label: "View Emails",
    slotKey: "surcharge-emails",
  },
  {
    label: "View SFDC Emails",
    slotKey: "surcharge-sfdc-emails",
  },
  {
    label: "Justification",
    slotKey: "justification",
  },
];

export const autoResolutionConstantData = {
  decision: "Potential Accept",
  type: "Full Waiver",
  expectedChargeAmount: "0",
};

export const algos = {
  algo4:
    "ANY CORRECTIVE ACTIONS WE ARE TAKING?\nIHE/IHI will be removed from GCSS\n\nWHY THIS IS AN INVOICE ERROR?\nActive shipment doesn’t have inland transportation service, hence Inland charges to be removed basis on direction(Export/Import/Both – IHE/IHI/IHE&IHI)\n\nWHAT SYSTEM CORRECTION WILL BE DONE IF APPROVED?\nIHE/IHI will be removed from GCSS",
  algo4_retcon:
    "ANY CORRECTIVE ACTIONS WE ARE TAKING?\nIdentify the retrospective contract lines through SAPI report and reprice the shipments\n\nWHY THIS IS AN INVOICE ERROR?\nShipments not repriced as per the contract lines filed, for which customer disputes\n\nWHAT SYSTEM CORRECTION WILL BE DONE IF APPROVED?\nShipments are identified for which retrospective contracting is done and its repriced",
};

export const getAutoResolutionForJustification = {
  IHI: {
    default: algos.algo4,
    "Retrospective Contracting": algos.algo4_retcon,
  },
  IHE: {
    default: algos.algo4,
    "Retrospective Contracting": algos.algo4_retcon,
  },
};

export const autoGamResolutionTableColumns = [
  {
    title: "Charge Code",
    slotKey: "charge_type",
    width: 160,
    isFrozen: true,
    customTooltip: false,
  },
  {
    title: "Algo Output",
    slotKey: "decision",
    width: 180,
    customTooltip: false,
  },
  {
    title: "Expected Amount",
    slotKey: "expectedAmount",
    width: 300,
    customTooltip: false,
  },
  {
    title: "Expected Quantity",
    slotKey: "expectedQuantity",
    width: 300,
    customTooltip: false,
  },
  {
    title: "Invoice Amount",
    slotKey: "invoiceBaseRate",
    width: 220,
    customTooltip: false,
  },
  {
    title: "Invoice Quantity",
    slotKey: "invoiceQuantity",
    width: 220,
    customTooltip: false,
  },
  {
    title: "Option for final outcome",
    slotKey: "outcome",
    width: 180,
    customTooltip: false,
  },
];

export const tableActionColumns = [
  {
    title: "Checkbox",
    slotKey: "checkbox",
    width: 48,
    isFrozen: true,
    type: "checkbox",
    sortable: true,
  },
];

export const autoResolutionOutcomeOptions = [
  {
    id: "accept",
    displayName: "Accept",
    label: "Accept",
    value: "accept",
  },
  {
    id: "reject",
    displayName: "Reject",
    label: "Reject",
    value: "reject",
  },
];

export const surchargeTabItems = [
  {
    title: "QSR Emails",
    id: "qsr-emails",
    active: true,
  },
  { title: "SFDC Emails", id: "sfdc-emails" },
];
